import { render, staticRenderFns } from "./ArticleResultBuilder.vue?vue&type=template&id=6d4205a0"
import script from "./ArticleResultBuilder.vue?vue&type=script&lang=js"
export * from "./ArticleResultBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports